<template>
    <div>
        <a-card type="inner" size="small">
            <a-spin v-if="loading" />
            <a-list item-layout="horizontal" :data-source="items.files" :loading="loading">
                <a-list-item slot="renderItem" slot-scope="item, index">
                    <a-list-item-meta
                        :description="moment(item.created_at).format('DD-MM-YYYY HH:mm:ss')"
                    >
                        <a slot="title" @click="download(item.attachment)">{{ item.file_name }}</a>
                    </a-list-item-meta>
                    <a-tooltip title="Hapus">
                        <a-button
                            v-if="!isAttendant"
                            size="small"
                            type="danger"
                            icon="delete"
                            @click="showConfirm(item.id)"
                        />
                    </a-tooltip>
                </a-list-item>
            </a-list>
        </a-card>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                required: true
            },
            cmc: {
                type: String,
                required: true
            },
            document: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                items: {
                    files: []
                },
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems() {
                this.loading = true;
                this.$http
                    .get(this.routeUri("api.cmc-files.files", {cmc: this.cmc}), {
                        params: {
                            type: this.document
                        }
                    })
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            download(url) {
                window.open(window.location.origin + url, '_blank')
            },
            showConfirm(file) {
                var msg = 'Anda yakin?'

                this.$confirm({
                    title: 'Konfirmasi',
                    content: msg,
                    onOk: () => {
                        this.handleDelete(file)
                    },
                    onCancel() {},
                    class: 'test',
                });
            },
            handleDelete(file) {
                this.processing = true;

                let promise;

                promise = this.$http.delete(
                    this.routeUri("api.cmc-files.files.destroy", { file: file, cmc: this.cmc })
                );

                promise
                    .then(response =>
                        this.handleSuccessResponse(response.data)
                    )
                    .catch(error =>
                        this.handleResponseError(error.response.data)
                    )
                    .finally(() => (this.processing = false));
            },
            handleSuccessResponse(data) {
                var successMessage = "Data berhasil diproses!";

                if (typeof data.successMessage != "undefined") {
                    successMessage = data.successMessage;
                }

                this.$notification.success({
                    message: "Sukses!",
                    description: successMessage
                });

                this.getItems()
            },
            handleResponseError(data) {
                if (data.hasOwnProperty("errors")) {
                    for (let key in data.errors) {
                        this.$notification.error({
                            message: "Gagal proses " + key,
                            description: Object.values(data.errors[key])
                        });
                    }
                } else {
                    this.$notification.error({
                        message: "Gagal proses",
                        description: "Data tidak dapat diproses."
                    });
                }
            },
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            },
            location(){
                return window.location.origin
            },
            isAttendant() {
                return this.$laravel.membership.is_attendant
            }
        }
    }
</script>